export default "export * from './components/'\nexport * from './hooks/'\n";